import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BrowserRouter as Router } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from './components/theme/ThemeProvider';
import { ThemeStyler } from './components/theme/ThemeStyler';
import { AuthProvider } from './contexts/AuthContext';
import { FocusTimerProvider } from './contexts/FocusTimerContext';
import { RouterSetup } from './components/routing/RouterSetup';
import { PWAInstallPrompt } from './components/PWAInstallPrompt';
import { SoundPlayerProvider } from './contexts/SoundPlayerContext';
import './styles.css';
import './styles/mobile.css';
// Create a client
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 5 * 60 * 1000, // 5 minutes
            gcTime: 10 * 60 * 1000, // 10 minutes
        },
    },
});
export default function App() {
    return (_jsx(QueryClientProvider, { client: queryClient, children: _jsx(AuthProvider, { children: _jsx(FocusTimerProvider, { children: _jsxs(ThemeProvider, { defaultTheme: "dark", children: [_jsx(ThemeStyler, {}), _jsx(SoundPlayerProvider, { children: _jsx(Router, { children: _jsx(RouterSetup, {}) }) }), _jsx(PWAInstallPrompt, {})] }) }) }) }));
}
